export default __webpack_public_path__ + "static/media/00.acfb24a6.jpg";